import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import PriorityList from './PriorityList';

const BalancingPriority = ({ name, props }) => {
    const { id } = useParams();
    const { watch, setValue } = useFormContext();
    const priorityList = watch(name);
    const isBalancingPriority = watch('priority_type') === 'balancing_plant';

    useEffect(() => {
        if (priorityList) {
            const processorInList = priorityList.some((processorId) => processorId === id);
            if (!isBalancingPriority && processorInList) {
                const updatedPriorityIds = priorityList.filter((processorId) => processorId !== id);
                setValue(name, updatedPriorityIds);
            }
        }
    }, [isBalancingPriority]);

    if (!isBalancingPriority) {
        return <Box />;
    }

    return (
        <Box ml={2}>
            <PriorityList props={props} />
        </Box>
    );
};

export default BalancingPriority;
